export const getFullNamePreview = ({
  name,
  educationLevel
}: {
  name?: string
  educationLevel?: string
}): string => (name && educationLevel ? `${name} ${educationLevel}` : '')
